enum Keys {
    THEME="THEME"
}

export default Keys;